import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';
import { ensurePxUnit } from '../../utils/mobileUtils';

export const TableWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Important for containing rounded corners */

  ${Styles.BorderStyles}
  background-color: #fff;
`;

export const TableHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  height: ${({ renderMode, headerHeight }) => 
    renderMode === 'preview' 
      ? (ensurePxUnit(headerHeight) || '25px') 
      : 'auto'
  };

  background: ${({ styleProps }) => {
    const startColor = styleProps?.headerBackgroundColor || '#f6f6f6';
    const endColor = styleProps?.headerBgColorGradient || startColor;
    if (startColor === endColor) return startColor;
    return `linear-gradient(to bottom, ${startColor}, ${endColor})`;
  }};
  color: ${({ styleProps }) => styleProps?.headerColor};
  font-family: ${({ styleProps }) => styleProps?.headerFontFamily};
  font-size: ${({ styleProps }) => ensurePxUnit(styleProps?.fontSize)};
  font-weight: ${({ styleProps }) => styleProps?.fontWeight};
  font-style: ${({ styleProps }) => styleProps?.fontStyle};
  border-bottom: 1px solid #ccc;
`;

export const TableHeaderCell = styled.div`
  padding: 4px 8px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: ${({ width }) => ensurePxUnit(width)};

  &:not(:last-child) {
    border-right: 1px solid #c5c5c5;
  }
`;

export const TableBody = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

export const TableRow = styled.div`
  display: flex;
  height: ${({ rowHeight }) => ensurePxUnit(rowHeight) || '25px'};

  /* Alternating row colors */
  &:nth-child(even) {
    background-color: ${({ styleProps }) => styleProps.alternateRowBgColor};
  }
  &:nth-child(odd) {
    background-color: ${({ styleProps }) => styleProps.normalRowBgColor};
  }
  opacity: .7;
`;

export const TableCell = styled.div`
  padding: 4px 8px;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: ${({ width }) => ensurePxUnit(width)};
  border-bottom: 1px solid #ccc;

  &:not(:last-child) {
    border-right: 1px solid #ccc;
  }
`;

export const TableFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 1px 1px 1px;
  border-top: 1px solid #c5c5c5;
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
  flex-shrink: 0;
`;

export const FooterButton = styled.button`
  border: 1px solid #bbb;
  background-color: #ABABAB;
  border-radius: 3px;
  width: 25px;
  height: 25px;
  margin-right: 3px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0px 2px 3px grey;

  &:hover {
    background-color: #d5d5d5;
  }
`;